import { configureStore } from "@reduxjs/toolkit";
import { ThemeSlice } from "./ThemeSlice/ThemeSlice";
import { DataSlice } from "./DataSlice/DataSlice";

export const LiquiBotSiteStore = configureStore({
    reducer : {
        theme: ThemeSlice.reducer,
        data: DataSlice.reducer
    }
})

export type RootState = ReturnType<typeof LiquiBotSiteStore.getState>
export type AppDispatch = typeof LiquiBotSiteStore.dispatch